<template>
  <HubPaywall />
</template>

<script>
import HubPaywall from '@/components/Hub/HubPaywall.vue'

export default {
  name: 'HubPaywallPage',

  components: { HubPaywall }
}
</script>
